import clsx from 'clsx';
import React from 'react';
import { useMedia } from 'react-use';

import { RadioButton } from '../../../atoms/radio/RadioButton';
import { RadioGroup } from '../../../atoms/radio/RadioGroup';
import { useSizeGuide } from '../useSizeGuide';

const RadioGroupRenderProp = (props) => {
  const { styles, sizeGuide, children } = props;
  const isMobile = useMedia('(max-width: 767px)', false);

  const { radioGroupRef, wrapperRef, newSizeGuide, onChangeRadio } =
    useSizeGuide({ sizeGuide, styles, isMobile });

  return (
    <>
      {children({
        radioGroupComponent: (
          <RadioGroupComponent
            styles={styles}
            onChangeRadio={onChangeRadio}
            wrapperRef={wrapperRef}
            radioGroupRef={radioGroupRef}
          />
        ),
        newSizeGuide,
        isMobile,
      })}
    </>
  );
};

const RadioGroupComponent = ({
  styles,
  wrapperRef,
  onChangeRadio,
  radioGroupRef,
}) => {
  return (
    <div className={clsx(styles.radioWrapper)} ref={wrapperRef}>
      <RadioGroup
        layout="column"
        customClasses={{
          column: styles.radioGroupColumn,
          root: styles.rootRadio,
          rootGroup: styles.rootGroup,
          groupColumn: styles.groupColumn,
          radiogroupWrapper: styles.radiogroupWrapper,
        }}
        onChange={onChangeRadio}
        ref={radioGroupRef}
      >
        <RadioButton
          value="cm"
          name="radio1"
          onlyText={true}
          label={<span>cm</span>}
        />
        <RadioButton
          value="inches"
          name="radio1"
          onlyText={true}
          label={<span>inches</span>}
        />
      </RadioGroup>
    </div>
  );
};

export default RadioGroupRenderProp;
